const EVENT = 'veltica:bookings-changed'

export function notifyBookingsChanged(projectId: string): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: projectId }))
}

export function onBookingsChanged(listener: (projectId: string) => void): () => void {
  const handler = (event: Event) => listener((event as CustomEvent<string>).detail)
  window.addEventListener(EVENT, handler)
  return () => window.removeEventListener(EVENT, handler)
}
